import React from "react";
import { motion } from "framer-motion";

function InvestorVaultAccess() {
  const items = [
    {
      title: "Live Vaults, Ready for Allocation",
      desc: "All QNC vaults are pre-deployed under verified strategy frameworks. Allocators can allocate capital instantly — no setup, integration, or management required.",
      ribbon: "Ready Access",
    },
    {
      title: "Secure, Non-Custodial",
      desc: "Funds remain under your direct control via Enzyme’s non-custodial smart contracts, integrated with qualified custodial infrastructure such as Kraken Institutional.",
      ribbon: "On-Chain Verified",
    },
    {
      title: "Minimum Allocation $25,000",
      desc: "Institutional access begins at $25 000, unlocking automated performance-based fee models and full transparency on-chain.",
      ribbon: "$25K Minimum",
    },
  ];

  return (
    <section
      id="vaults"
      className="relative py-28 bg-gradient-to-b from-white to-gray-50 overflow-hidden"
    >
      {/* Subtle animated background grid */}
      <div className="absolute inset-0 -z-0 opacity-20 pointer-events-none">
        <svg
          className="w-full h-full animate-[gridmove_60s_linear_infinite]"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMidYMid slice"
        >
          <defs>
            <pattern id="grid" width="50" height="50" patternUnits="userSpaceOnUse">
              <path
                d="M50 0H0V50"
                fill="none"
                stroke="#0A2A66"
                strokeOpacity="0.15"
                strokeWidth="1"
              />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      <style>
        {`
          @keyframes gridmove {
            0% { transform: translate(0, 0); }
            50% { transform: translate(25px, 25px); }
            100% { transform: translate(0, 0); }
          }
        `}
      </style>

      <div className="relative z-10 max-w-6xl mx-auto px-6">
        {/* Section label */}
        <motion.div
          className="text-center mb-6"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="inline-block text-xs tracking-wider font-semibold uppercase text-cyan-700 bg-cyan-50 px-4 py-1 rounded-full">
            Investor Access
          </span>
        </motion.div>

        {/* Heading */}
        <motion.h2
          className="text-4xl md:text-5xl font-bold text-center mb-16 text-gray-900"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          Ready Vault Access
        </motion.h2>

        {/* Cards with ribbons */}
        <div className="grid md:grid-cols-3 gap-10">
          {items.map((i, idx) => (
            <motion.div
              key={idx}
              className="group relative bg-white p-10 rounded-2xl shadow-md border border-gray-100 overflow-hidden"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: idx * 0.15 }}
            >
              {/* Ribbon */}
              {i.ribbon && (
                <div className="absolute -right-16 top-5 rotate-45">
                  <span className="bg-gradient-to-r from-cyan-500 to-blue-600 text-white text-[10px] font-semibold tracking-wide px-16 py-1 shadow-md">
                    {i.ribbon}
                  </span>
                </div>
              )}

              {/* Accent bar animation */}
              <div className="absolute top-0 left-0 h-1 w-0 bg-gradient-to-r from-cyan-500 to-blue-600 group-hover:w-full transition-all duration-500"></div>

              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                {i.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">{i.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default InvestorVaultAccess;
